<template>
    <el-form ref="form" :rules="rules" :model="form" @submit.prevent.native="formSubmit('form')">

        <el-form-item prop="username">
            <el-input ref="username" v-model="form.username" placeholder="username"></el-input>
        </el-form-item>

        <el-form-item prop="password">
            <el-input v-model="form.password" type="password" placeholder="password"></el-input>
        </el-form-item>

        <el-form-item>
            <el-button native-type="submit" type="primary" v-loading.fullscreen.lock="loading" class="button">Login</el-button>
            <!-- <div class="row">
                <div class="col-lg-12">
                    <div class="flex-space">
                        <el-link type="primary" href="/password/reset" v-text="$t('auth.password_forgot')"></el-link>
                    </div>
                </div>
            </div> -->
        </el-form-item>

    </el-form>
</template>

<script>
import { HTTP } from '@/services/api'

export default {
  name: 'Login',
  metaInfo () {
    return {
      title: 'Login'
    }
  },
  data () {
    return {
      loading: false,
      form: {
        username: null,
        password: null
      },
      rules: {
        username: [
          { required: true, message: 'Please enter your email', trigger: 'blur' },
          { type: 'email', message: 'You have to enter valid email', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Please enter your password', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    if (!(Object.keys(this.$store.state.auth).length === 0 && this.$store.state.auth.constructor === Object)) {
      this.$router.push({ name: 'home' })
    } else {
      this.$refs.username.focus()
    }
  },
  methods: {
    formSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          HTTP({
            method: 'POST',
            url: '/api/v1/login',
            crossdomain: true,
            data: this.form
          })
            .then(response => {
              this.$store.dispatch('setAuth', response.data).then(() => {
                this.loadUser()
                this.loadFavorites()
              })
            })
            .catch(error => {
              this.loading = false
              this.$notify({
                // title: 'Error',
                dangerouslyUseHTMLString: true,
                message: error.response.data ? this.parseErrorMessage(error.response.data.error) : 'Error occured. Please try later',
                type: 'error',
                position: 'bottom-right',
                duration: 1750
              })
            })
        } else {
          return false
        }
      })
    },
    loadUser () {
      HTTP({
        method: 'GET',
        url: '/api/v1/users/profile',
        crossdomain: true
      })
        .then(response => {
          this.$store.dispatch('setUser', response.data.data).then(() => {
            this.$store.dispatch('removeRequestItem', {
              item: {},
              all: true
            })
            window.localStorage.setItem('user', JSON.stringify(response.data.data))
            this.$router.push({ name: 'home', query: this.$route.query })
          })
        })
        .catch(error => {
          this.$notify({
            // title: 'Error',
            message: error.response.data ? error.response.data.error.message : 'Error occured. Please try later',
            type: 'error',
            position: 'bottom-right',
            duration: 1750
          })
          this.loading = false
          this.$store.dispatch('setLogout')
        })
    },
    loadFavorites () {
      HTTP({
        method: 'GET',
        url: '/api/v1/favorites/ids',
        crossdomain: true
      }).then(response => {
        this.$store.dispatch('setFavorites', response.data.data)
      }).catch(() => {
      })
    }
  }
}
</script>
